import { Avatar, styled, Typography } from "@material-ui/core";
import { ListItemText } from "@material-ui/core";
import BeerIcon from '@material-ui/icons/LocalDrink';

export const BeerName = styled(({ preSelectedIndex, ...p }) =>
    <ListItemText
        primaryTypographyProps={{
            className: ((preSelectedIndex >= 0) ? 'selected' : undefined)
        }}
        secondary={(preSelectedIndex >= 0) &&
            `Selected in round ${preSelectedIndex + 1}`
        }
        {...p}
    />
)(({ theme }) => ({
    '& .selected': {
        opacity: 0.5
    }
}));

export const BeerItemPropertyTitle = styled((p) =>
    <Typography
        component="span"
        variant="body2"
        color="textPrimary"
        {...p}
    >
        {p.children}
    </Typography>)(({ theme }) => ({
        fontWeight: 500,
        display: "inline-block",
        marginTop: "10px"
    }));
export const BeerItemPropertyDescription = styled((p) =>
    <Typography
        component="span"
        variant="body2"
        color="textPrimary"
        {...p}
    >
        {` — ${p.children}`}<br />
    </Typography>)(({ theme }) => ({
        fontWeight: 300,
    }));

export const BeerImage = styled(({ beer, ...p }) =>
    <Avatar variant={beer?.imageUrl ? "square" : "circle"} alt={beer.id} src={beer.imageUrl!} {...p} ><BeerIcon /></Avatar>
)(({ theme }) => ({
    height: "80px",
    width: "80px",
    marginRight: theme.spacing(2),
    "& .MuiAvatar-img": {
        objectFit: 'contain',
    }
}));